import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import './index.css';
import { Provider } from 'react-redux';
import store from './app/store';
import * as serviceWorker from './serviceWorker';
import AppRouter from './router';
import theme from './theme';
import SocketListener from './api/socketlistener';


SocketListener.setDispatch(store.dispatch);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <AppRouter />
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
